import React from 'react';
import './KnowSection.css';
import KnowTitle from './image/Knowtitle.svg';
import Know1 from './image/Know1.svg';
import Know2 from './image/Know2.svg';
import Know3 from './image/Know3.svg';

const KnowSection = () => {
  return (
    <div className="know-section">
      <div className="know-title-container">
        <img src={KnowTitle} alt="Why We Do This?" className="know-title" />
      </div>
      <div className="know-items">
        <div className="know-item">
          <img src={Know1} alt="Target" className="know-icon" />
        </div>
        <div className="know-item">
          <img src={Know2} alt="Vision" className="know-icon" />
        </div>
        <div className="know-item">
          <img src={Know3} alt="Goals" className="know-icon" />
        </div>
      </div>
    </div>
  );
};

export default KnowSection;
